import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmpleadosServicio } from '../../services/empleado.service';

const NAVBAR = [
  { ID: 1, routerLink: ['/inicio'], fontAwesome: 'fa fa-dashboard fa-fw', txt: 'Tablero', children: [] },
  { ID: 2, routerLink: ['/lista/apertura-dia'], fontAwesome: 'fa fa-sun-o fa-fw', txt: 'Cuadre de caja', children: [] },
  { ID: 35, routerLink: ['/token'], fontAwesome: 'fa fa-lock', txt: 'Token', children: [] },
  { ID: 3, routerLink: ['/lista/clientes'], fontAwesome: 'fa fa-users', txt: 'Clientes', children: [] },
  { ID: 4, routerLink: ['/cuota'], fontAwesome: 'fa fa-area-chart', txt: 'Cuota', children: [] },
  { ID: 5, routerLink: ['/lista/gastos-dietas'], fontAwesome: 'fa fa-pie-chart', txt: 'Gastos', children: [] },
  { ID: 6, routerLink: ['/lista/notas'], fontAwesome: 'fa fa-book', txt: 'Notas', children: [] },
  { ID: 7, routerLink: ['/lista/prestamos'], fontAwesome: 'fa fa-usd', txt: 'Préstamos', children: [] },
  { ID: 8, routerLink: ['/lista/pre-solicitudes-prestamos'], fontAwesome: 'fa fa-money', txt: 'Solicitudes préstamos', children: [] },
  {
    ID: 0, routerLink: [],
    fontAwesome: 'fa fa-sitemap fa-fw',
    txt: 'Cobros',
    children: [
      { ID: 9, routerLink: ['/lista/cobros'], txt: 'Lista cobros' },
      { ID: 10, routerLink: ['/lista/recibos'], fontAwesome: '', txt: 'Recibos' },
      { ID: 11, routerLink: ['/lista/cobros-por-zona'], fontAwesome: '', txt: 'Por zona' },
    ]
  },
  {
    ID: 0, routerLink: [],
    fontAwesome: 'fa fa-file-text fa-fw',
    txt: 'Reportes',
    children: [
      { ID: 12, routerLink: ['/reporte/anticipos'], txt: 'Anticipos' },
      { ID: 13, routerLink: ['/reporte/atrasos-por-ruta'], txt: 'Atrasos por Zona' },
      { ID: 14, routerLink: ['/lista/cuadres-con-faltante'], txt: 'Cuadres con faltante' },
      { ID: 15, routerLink: ['/lista/prestamos-cuotas-vencidas'], txt: 'Cuotas vencidas' },
      { ID: 16, routerLink: ['/reporte/control-cobros'], txt: 'Control de cobros' },
      { ID: 17, routerLink: ['/lista/reporte-cobros-dia'], txt: 'Cobros del día' },
      { ID: 18, routerLink: ['/reporte/cuentas-por-cobrar'], txt: 'Cuentas por cobrar' },
      { ID: 19, routerLink: ['/reporte/datacredito'], txt: 'Datacredito' },
      { ID: 20, routerLink: ['/reporte/dinero-entregado'], txt: 'Dinero entregado' },
      { ID: 21, routerLink: ['/reporte/saldaron-no-renovaron'], txt: 'Saldaron no Renovaron' },
      { ID: 22, routerLink: ['/reporte/diario'], txt: 'Diario' },
      { ID: 32, routerLink: ['/reporte/semanal'], txt: 'Semanal' },
      { ID: 33, routerLink: ['/reporte/semanal-empresas'], txt: 'Consolidado' },
      { ID: 36, routerLink: ['/reporte/consolidado-ciudades'], txt: 'Consolidado Por Ciudad' },
      { ID: 34, routerLink: ['/reporte/informe-general'], txt: 'Informe General' },
      { ID: 23, routerLink: ['/reporte/gastos'], txt: 'Gastos' },
      { ID: 24, routerLink: ['/lista/prestamos-salientes'], txt: 'Préstamos salientes' },
      { ID: 25, routerLink: ['/lista-prestamos-vencidos'], txt: 'Préstamos vencidos' },
      { ID: 26, routerLink: ['/lista/clientes/incobrables'], txt: 'Préstamos incobrables' },
      { ID: 27, routerLink: ['/reporte/rentabilidad-ruta'], txt: 'Rentabilidad ruta' },
    ]
  },
  { ID: 29, routerLink: ['/lista/empleado'], fontAwesome: 'fa fa-user fa-fw', txt: 'Empleados', children: [] },
  { ID: 30, routerLink: ['/lista/rutas'], fontAwesome: 'fa fa-map fa-fw', txt: 'Zonas', children: [] },
  { ID: 31, routerLink: ['/regiones'], fontAwesome: 'fa fa-map-marker fa-fw', txt: 'Regiones', children: [] },
  { ID: 28, routerLink: ['/configuraciones'], fontAwesome: 'fa fa-gears', txt: 'Configuraciones', children: [] },
];

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']

})
export class NavbarComponent implements OnInit {
  menu = NAVBAR;
  busquedaCliente: string;
  navbarFixed: boolean; // Esto es para agregar una clase ('navbar-fixed') al navbar, si es true
  stickyNav = false;
  constructor(
    private route: Router,
    private empleadoService: EmpleadosServicio) {
      if (this.empleadoService.datosEmpleado.tipo_empleado === 1) {
        this.menu = this.menu.filter((menu: any) => {
          const idpage = this.empleadoService.paginasAsignadas.map(page => page.ID_PAGINA);
          if (menu.children.length) {

            menu.children = menu.children.filter(child => idpage.includes(child.ID));
            return menu.children.length > 0;
          }

          return idpage.includes(menu.ID);
        });
      }
  }

  ngOnInit() {
    this.initConfigMultiSelect();
    window.onresize = () => this.initConfigMultiSelect();
  }

  buscarCliente() {
    if (this.busquedaCliente) {
      localStorage.setItem('busqueda', this.busquedaCliente);
      this.route.navigate(['/lista-clientes']);
    }
  }


  onWindowScroll(event: any) {
    const number = document.body.scrollTop || document.documentElement.scrollTop || 0;
      this.navbarFixed = false;
      if (number > 60) {
        this.navbarFixed = false;
      } else if (this.navbarFixed && number < 50) {
        this.navbarFixed = false;
      }
  }

  private initConfigMultiSelect() {
    if (window.matchMedia('(max-width: 992px)').matches) {
      this.stickyNav = false;
    } else {
      this.stickyNav = true;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/navbar/navbar.component.ts